import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import FabricDescription from './FabricDescription';
import Footer from './Footer';
import HeroImageText from '../Hero/ImageText';
import ShopSegments from './ShopSegments';
import UGC from './UGC';
import css from './ProductSpotlightStatic.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ProductSpotlightStatic = function ProductSpotlightStatic(_ref) {
  var fabricDescription = _ref.fabricDescription,
      footer = _ref.footer,
      hero = _ref.hero,
      heroMobile = _ref.heroMobile,
      _ref$shopSegments = _ref.shopSegments,
      segments = _ref$shopSegments.segments,
      shopSegmentsTitle = _ref$shopSegments.title,
      ugc = _ref.ugc;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(HeroImageText, _objectSpread(_objectSpread({}, hero), {}, {
      centerContent: true,
      className: cc([css.hero, css.desktop]),
      fullHeight: true
    })), /*#__PURE__*/_jsx(HeroImageText, _objectSpread(_objectSpread({}, heroMobile), {}, {
      centerContent: true,
      className: cc([css.hero, css.mobile]),
      fullHeight: true
    })), /*#__PURE__*/_jsx(FabricDescription, _objectSpread({}, fabricDescription)), /*#__PURE__*/_jsx(ShopSegments, {
      segments: segments,
      title: shopSegmentsTitle
    }), /*#__PURE__*/_jsx(UGC, _objectSpread({}, ugc)), /*#__PURE__*/_jsx(Footer, _objectSpread({}, footer))]
  });
};

ProductSpotlightStatic.propTypes = {
  fabricDescription: PropTypes.shape().isRequired,
  footer: PropTypes.shape().isRequired,
  hero: PropTypes.shape(_objectSpread({}, HeroImageText.propTypes)).isRequired,
  heroMobile: PropTypes.shape(_objectSpread({}, HeroImageText.propTypes)).isRequired,
  shopSegments: PropTypes.shape({
    segments: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  ugc: PropTypes.shape().isRequired
};
export default ProductSpotlightStatic;